import { render, staticRenderFns } from "./Gem.vue?vue&type=template&id=6eb0a822&"
import script from "./Gem.vue?vue&type=script&lang=js&"
export * from "./Gem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eb0a822')) {
      api.createRecord('6eb0a822', component.options)
    } else {
      api.reload('6eb0a822', component.options)
    }
    module.hot.accept("./Gem.vue?vue&type=template&id=6eb0a822&", function () {
      api.rerender('6eb0a822', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/repositories/Gem.vue"
export default component.exports